import { create } from "../../../common/utils/zustand_state_manager";
import { IControlePatrimonioService } from "../../../features/controledePatrimonio/data/services/controlePatrimonioService";
import { ControlePatrimonioService } from "../../../features/controledePatrimonio/data/services/controlePatrimonioService_impl";

/**
 * useControlePatrimonioServices
 */

type State = {
  controlePatrimonioService: IControlePatrimonioService;
};

export const useControlePatrimonioServices = create<State>((set, get) => ({
  controlePatrimonioService: new ControlePatrimonioService(),
}));
